import axios, { AxiosError } from 'axios';
import { SELF_SERVICE_API_URL } from 'config';
import type { SelfServiceAPI } from 'types';
import handleServiceError from '../utils/handleServiceError';

interface Data {
  bookingId: string;
  cancellationId: string;
}

interface Options {
  skipUnauthenticatedRedirection?: boolean;
  retry?: boolean;
}

const getCancellation = async (
  { bookingId, cancellationId }: Data,
  options: Options = {},
): Promise<SelfServiceAPI.GetCancellation.Response> => {
  try {
    const { data } = await axios.get<SelfServiceAPI.GetCancellation.Response>(
      `${SELF_SERVICE_API_URL}/bookings/${bookingId}/cancellations/${cancellationId}`,
      {
        withCredentials: true,
      },
    );

    return data;
  } catch (error) {
    if (options.retry !== false) {
      const status = error instanceof AxiosError && error.response?.status;

      if (status === 500) {
        return await getCancellation({ bookingId, cancellationId }, { ...options, retry: false });
      }
    }

    handleServiceError(error, {
      operationName: `GET /bookings/${bookingId}/cancellations/${cancellationId}`,
      skipUnauthenticatedRedirection: options.skipUnauthenticatedRedirection,
    });

    return new Promise(() => {});
  }
};

export default getCancellation;
